module.exports = __webpack_public_path__ + "assets/agency-459f9e868113404369ee1911dbea047d.png";